import { render, staticRenderFns } from "./VColorInput.vue?vue&type=template&id=a0cdef1e&"
import script from "./VColorInput.vue?vue&type=script&lang=js&"
export * from "./VColorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports